import './index.css';
import React from 'react';
import { createRoot } from 'react-dom/client';

// 静的インポートに変更（本番環境での動的インポートエラー対策）
/* eslint-disable no-unused-vars */
import ErrorBoundary from './components/ErrorBoundary.jsx';
import AppNoWallet from './App-NoWallet.jsx';
import AppRailway from './App-Railway.jsx';
/* eslint-enable no-unused-vars */

// Viteキャッシュ自動クリーンアップ（開発環境のみ）
import viteCacheManager from './utils/viteCache.js';
if (import.meta.env.DEV) {
  viteCacheManager.init();
}

// デプロイ後の古いチャンクファイル参照エラーを検知して自動リロード
window.addEventListener('error', (event) => {
  if (event.message?.includes('Failed to fetch dynamically imported module')) {
    window.location.reload();
  }
});
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.message?.includes('Failed to fetch dynamically imported module')) {
    window.location.reload();
  }
});

// エラーモニタリングシステム（Vercel本番環境対応）
// 動的インポートのビルドエラーを回避するため、単純化

// グローバルエラーハンドリング（Vercel本番環境対応）
// 動的インポートのビルドエラーを回避するため、単純化

// 関数デバッガー（開発環境のみ・Vercel対応）

// 【本番環境対応】Railway環境の判定
const isActualRailwayEnv =
  typeof import.meta !== 'undefined' &&
  import.meta.env &&
  import.meta.env.VITE_RAILWAY === 'true' &&
  typeof window !== 'undefined' &&
  window.location.hostname.includes('railway.app');

// React DevTools警告の抑制（開発環境のみ）
if (import.meta.env.DEV) {
  const originalWarn = console.warn;
  console.warn = (...args) => {
    const message = args.join(' ');
    if (message.includes('React DevTools') && message.includes('too old')) {
      return;
    }
    originalWarn.apply(console, args);
  };
}

// 開発環境でService Workerをアンレジスター（Workboxログ防止）
if (import.meta.env.DEV && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister();
    });
  });
}

// 本番環境でService Workerの更新チェック（VitePWA自動生成のSWを使用）
// 注: 頻繁な更新チェックによるネットワークエラーを防ぐため、自動更新を無効化
// Service Workerはビルド時にVitePWAによって自動登録される
/*
if (!import.meta.env.DEV && 'serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then((registration) => {
    setInterval(() => {
      registration.update();
    }, 60000);
  }).catch((error) => {
    console.error('Service Worker registration failed:', error);
  });
}
*/

// 開発環境でのみStrictModeを有効化（本番環境ではユーザー体験を優先）
// 注: チャットスクロール問題のため一時的に無効化
const isDevelopment = false; // import.meta.env.DEV;
const StrictMode = React.StrictMode; // eslint-disable-line no-unused-vars

// グローバルエラー表示機構（モバイルデバッグ用）
if (typeof window !== 'undefined') {
  let errorOverlay = null;

  window.showMobileError = function(message) {
    // 既存のエラーオーバーレイがあれば削除
    if (errorOverlay && errorOverlay.parentNode) {
      errorOverlay.parentNode.removeChild(errorOverlay);
    }

    // エラーオーバーレイを作成
    errorOverlay = document.createElement('div');
    errorOverlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.8);
      z-index: 10000;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px;
    `;

    const errorBox = document.createElement('div');
    errorBox.style.cssText = `
      background-color: white;
      border-radius: 12px;
      padding: 24px;
      max-width: 500px;
      width: 100%;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    `;

    const errorTitle = document.createElement('div');
    errorTitle.textContent = '⚠️ エラー';
    errorTitle.style.cssText = `
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 16px;
      color: #dc2626;
    `;

    const errorMessage = document.createElement('div');
    errorMessage.textContent = message;
    errorMessage.style.cssText = `
      font-size: 14px;
      margin-bottom: 20px;
      color: #374151;
      white-space: pre-wrap;
      word-break: break-word;
    `;

    const okButton = document.createElement('button');
    okButton.textContent = 'OK';
    okButton.style.cssText = `
      width: 100%;
      padding: 12px;
      background-color: #3b82f6;
      color: white;
      border: none;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      transition: background-color 0.2s;
    `;

    // OKボタンのクリックイベント（タッチイベントも対応）
    const closeError = function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (errorOverlay && errorOverlay.parentNode) {
        errorOverlay.parentNode.removeChild(errorOverlay);
        errorOverlay = null;
      }
    };

    okButton.addEventListener('click', closeError, { passive: false });
    okButton.addEventListener('touchend', closeError, { passive: false });

    // ホバー効果
    okButton.addEventListener('mouseenter', () => {
      okButton.style.backgroundColor = '#2563eb';
    });
    okButton.addEventListener('mouseleave', () => {
      okButton.style.backgroundColor = '#3b82f6';
    });

    // オーバーレイクリックで閉じる
    errorOverlay.addEventListener('click', function(e) {
      if (e.target === errorOverlay) {
        closeError(e);
      }
    });

    errorBox.appendChild(errorTitle);
    errorBox.appendChild(errorMessage);
    errorBox.appendChild(okButton);
    errorOverlay.appendChild(errorBox);
    document.body.appendChild(errorOverlay);
  };
}

// モバイルデバッグ用関数（予備）
// eslint-disable-next-line no-unused-vars
function showMobileDebug(msg) {
  if (typeof window !== 'undefined' && window.showMobileError) {
    window.showMobileError(msg);
  }
}

try {
  if (isActualRailwayEnv) {
    const app = <AppRailway />;
    createRoot(document.getElementById('root')).render(
      isDevelopment ? <StrictMode>{app}</StrictMode> : app
    );
  } else {
    const app = (
      <ErrorBoundary>
        <AppNoWallet />
      </ErrorBoundary>
    );
    createRoot(document.getElementById('root')).render(
      isDevelopment ? <StrictMode>{app}</StrictMode> : app
    );
  }
} catch (error) {
  console.error('App initialization error:', error);
  // フォールバック表示
  document.getElementById('root').innerHTML =
    '<div style="padding:20px;color:red;">App initialization failed. Please refresh.</div>';
}
